const routeTo = {
  getUrl(value) {
    let path = '';
    if (value.type === 'customized') {
      if (value.url.indexOf('?') !== -1) {
        const paramIndex = value.url.lastIndexOf('?');
        path = `/${value.url.slice(0, paramIndex).toUpperCase()}/${value.id}${value.url.slice(paramIndex)}`;
      } else {
        path = `/${value.url.toUpperCase()}/${value.id}`;
      }
    }
    return path;
  },
  routeTo(data) {
    const {
      type
    } = data;
    const { value, id, url } = data;
    this.jumpTo({ type, info: { tableName: value, tableId: id, url } });
  },
  jumpTo({ type, info }) {
    let path = '/';
    let query = {};
    const LINK_MODULE_PREFIX = '/LINK';
    const STANDARD_TABLE_LIST_PREFIX = '/SYSTEM/TABLE';
    const STANDARD_COMMONTABLE_LIST_PREFIX = '/SYSTEM/COMMONTABLE';
    switch (type) {
      case 'action':
        if (info.url) {
          const actionType = info.url.substring(0, info.url.indexOf('/'));
          if (actionType === 'SYSTEM') {
            path = `/${info.url}`;
          } else if (actionType === 'https:' || actionType === 'http:') {
            path = `${LINK_MODULE_PREFIX}/${info.tableName.toUpperCase()}/${info.tableId}`;
          } else if (actionType.toUpperCase() === 'CUSTOMIZED') {
            path = this.getUrl({ url: info.url, id: info.tableId, type: 'customized' });
          } else {
            class Person {
              constructor(wrong, eg, url) {
                this.wrong = wrong;
                this.correctURL = eg;
                this.url = url;
              }
            }
            const me = new Person('url配置错误', 'SYSTEM/TABLE_DETAIL/V/DL_B_PUR/23792/New', info.url);
            console.table(me);
          }
        }
        break;
      case 'table':
        path = `${STANDARD_TABLE_LIST_PREFIX}/${info.tableName}/${info.tableId}`;
        break;
      case 'tree':
        path = `${STANDARD_TABLE_LIST_PREFIX}/${info.tableName}/${info.tableId}`;
        query = {
          isTreeTable: true
        };
        break;
      case 'commonTable':
        path = `${STANDARD_COMMONTABLE_LIST_PREFIX}/${info.tableName}/${info.tableId}`;
        break;
      default:
        break;
    }
    if (window.vm.$router.currentRoute.fullPath !== path) {
      window.vm.$router.push({ path, query }).catch((e) => { console.error(t('当前单据已打开')); });
    }
  },
}

export default routeTo